import src from "IMAGE";
export default { src, width: 211, height: 254, blurWidth: 0, blurHeight: 0};
